import React from "react";
import { Component, Fragment } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,
	Button,
	Progress,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as mqtt from 'react-paho-mqtt';
import Paho from 'paho-mqtt';
import { getConnectionURL } from "../../mqtt-helpers/mqtt-request";
import { authenticationService } from '../../jwt/_services';
import ReactGA from "react-ga4";
import { getDevicePageTitle, isNovaDevice as isNovaProduct } from './product-title';

import {
	TopProceduresCat,
	BatteryHealth,
	Booster200V,
	WavelengthUsage,
	WifiStrength,
	VisualAudioStatus,
	TotalHourlyUsagePVM,
	BleStrength
} from '../../components/vitals/';
import {
	TopProceduresCatNova
} from '../../components/mobile-vitals-dashboard/';

class Vitals extends React.Component {

	connectionTimeout = null;
	connectionTimeoutDelay = 15000;

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info: ' + JSON.stringify(currentUser.token));

		this.onMessageArrived = this.onMessageArrived.bind(this);
    this.onConnectionLost = this.onConnectionLost.bind(this);

		// var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    // console.log('random hash: ' + hash);
		// const client = new Paho.Client(getConnectionURL(), hash+this.props.match.params.id);
    // client.onMessageArrived = this.onMessageArrived;
    // client.onConnectionLost = this.onConnectionLost;
    // client.connect({
		// 	timeout: 3,
		// 	useSSL: true,
		// 	mqttVersion: 4,
		// 	cleanSession: true,
		// 	onSuccess: this.onConnect,
		// 	onFailure: (e) => {console.log("here is the error" , e); }
    // });

    this.state = {
			userVitalsHistoryData: null,
			mainMessage: [''],
			noDevices: false,
			subMessage: [''],
			client: null,
			currentUser,
      messageToSend:'',
			currentDevice: this.props.match.params.id,
      isConnected: false,
			isReceivingMessages: false,
			devices: JSON.parse(localStorage.getItem('deviceList')),
	  };

  }

	componentDidMount() {

		ReactGA.pageview(window.location.pathname);

		this.connectToMQTT();

		if (this.state.currentDevice === "00000") {
			this.setState({noDevices: true});
		}

		this.getUserVitalsHistoryData();
		//setInterval(this.checkIsConnected, 2000);
	}

	componentDidUpdate(prevProps) {
		const nextDevice = this.props.match.params.id;

		if (prevProps.match.params.id !== nextDevice) {
			if (this.state.client && this.state.client.isConnected()) {
				this.state.client.disconnect();
			}

			clearTimeout(this.connectionTimeout);

			this.setState({
				currentDevice: nextDevice,
				userVitalsHistoryData: null,
				mainMessage: [''],
				subMessage: [''],
				client: null,
				isConnected: false,
				isReceivingMessages: false,
				noDevices: nextDevice === "00000"
			}, () => {
				this.connectToMQTT();
				this.getUserVitalsHistoryData();
			});
		}
	}

	componentWillUnmount() {

		//var currentConnectedDevice = JSON.parse(localStorage.getItem('currentConnectedDevice'));

		// if (currentConnectedDevice == this.state.currentDevice) {
		// 	localStorage.setItem('currentConnectedDevice', '');
		// 	localStorage.setItem('isDeviceReceivingMessages', false);
		// }

		if (this.state.client && this.state.client.isConnected()) {
			this.state.client.disconnect();
		}

		clearTimeout(this.connectionTimeout);

	}

	getUserVitalsHistoryData = async () => {

		var productFilter = this.isNovaDevice() ? "&ProductID=2" : "";
		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-dashboard-user-vitals-history?SerialNumber="+this.state.currentDevice+productFilter;

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("getUserVitalsHistoryData response: " + JSON.stringify(body));

			if (body.status == 'Success' && body.response && body.response.length>0) {

				console.log("getUserVitalsHistoryData response: " + JSON.stringify(body.response[0].Data));

				const parsedHistoryData = this.parseVitalsHistoryData(body.response[0].Data);
				console.log("getUserVitalsHistoryData Data: " + JSON.stringify(parsedHistoryData));

				if (!parsedHistoryData) {
					return;
				}

				var historyMessage = this.normalizeVitalsMessage(parsedHistoryData);
				console.log("historyMessage: " + JSON.stringify(historyMessage));
				console.log("historyMessage fw_up: " + JSON.stringify(historyMessage && historyMessage.fw_up));

				this.setState({ userVitalsHistoryData: historyMessage });
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	isNovaDevice = () => {
		return isNovaProduct(this.state.currentDevice, this.state.devices);
	}

	parseVitalsHistoryData = (data) => {
		if (!data) {
			return null;
		}

		if (typeof data !== "string") {
			return data;
		}

		try {
			const parsed = JSON.parse(data);

			if (typeof parsed === "string") {
				return this.parseVitalsHistoryData(parsed);
			}

			return parsed;
		}
		catch (err) {
			console.log("parseVitalsHistoryData error: "+err);
			return null;
		}
	}

	getNovaVitalsPayload = (message) => {
		if (!message) {
			return {};
		}

		const candidates = [
			message,
			message.nova,
			message.data,
			message.message,
			message.payload,
			message.payloadString
		];

		for (var i=0; i<candidates.length; i++) {
			let candidate = candidates[i];

			if (!candidate) {
				continue;
			}

			if (typeof candidate === "string") {
				candidate = this.parseVitalsHistoryData(candidate);
			}

			if (candidate && (candidate.base || candidate.wand || candidate.pedal)) {
				return candidate;
			}
		}

		return message;
	}

	getNumber = (value) => {
		const number = Number(value);
		return Number.isFinite(number) ? number : null;
	}

	normalizeVoltageToMillivolts = (value) => {
		const voltage = this.getNumber(value);

		if (voltage == null) {
			return undefined;
		}

		if (voltage<100) {
			return voltage*1000;
		}

		return voltage;
	}

	getRssiBars = (rssi) => {
		const value = this.getNumber(rssi);

		if (value == null || value==0) {
			return 0;
		}

		if (value>-55) {
			return 4;
		} else if (value>-75) {
			return 3;
		} else if (value>-90) {
			return 2;
		}

		return 1;
	}

	getLegacyBatteryLevel = (level) => {
		const value = this.getNumber(level);

		if (value == null) {
			return undefined;
		}

		const percent = value>1 ? value : value*100;

		if (percent<35) {
			return 1;
		} else if (percent<65) {
			return 2;
		}

		return 3;
	}

	normalizeNovaVitalsMessage = (message) => {
		if (!message) {
			return message;
		}

		const novaPayload = this.getNovaVitalsPayload(message);
		const base = novaPayload.base || {};
		const wand = novaPayload.wand || {};
		const pedal = novaPayload.pedal || {};
		const batteryVoltage = this.normalizeVoltageToMillivolts(base.battery_voltage);
		const pedalBle = pedal.connected_to_base===false ? 0 : this.getRssiBars(pedal.ble_signal_strength);
		const wandBle = wand.connected_to_base===false ? 0 : this.getRssiBars(wand.ble_signal_strength);
		const ble = pedalBle || wandBle;
		const normalizedSource = {
			...message,
			...novaPayload
		};

		return {
			...message,
			...novaPayload,
			nova: novaPayload,
			V: normalizedSource.V || batteryVoltage,
			vsys: normalizedSource.vsys || batteryVoltage,
			I: normalizedSource.I || 0,
			dc: base.power_in_attached ? 16000 : 0,
			hv: normalizedSource.hv || base.display_voltage || base.hv,
			wifi: normalizedSource.wifi || base.wifi_strength,
			wifi_ssid: normalizedSource.wifi_ssid || base.wifi_name,
			ble,
			pedal_batt: normalizedSource.pedal_batt || this.getLegacyBatteryLevel(pedal.battery_level),
			fw_ver: normalizedSource.fw_ver || normalizedSource.firmware_version || 2,
			wand_connected: wand.connected_to_base,
			wand_temperature: wand.laser_internal_temperature,
			pedal_connected: pedal.connected_to_base,
			base_battery_level: base.battery_level,
			base_battery_voltage: base.battery_voltage,
			power_in_attached: base.power_in_attached,
			wifi_connected: base.wifi_connected
		};
	}

	normalizeVitalsMessage = (message) => {
		if (this.isNovaDevice()) {
			return this.normalizeNovaVitalsMessage(message);
		}

		return message;
	}

	connectToMQTT = async () => {
		const isNovaDevice = this.isNovaDevice();
		const productID = isNovaDevice ? 2 : null;

		authenticationService.getDeviceConnectionURL(this.state.currentDevice, productID)
				.then(
						connectionUrl => {
							console.log('connectToMQTT connectionUrl: ' + JSON.stringify(connectionUrl));

							//var url1 = "wss://a1f3ynjyzalf3r-ats.iot.us-west-2.amazonaws.com/mqtt?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAS3T2QUYOSMZKW4V2%2F20210201%2Fus-west-2%2Fiotdevicegateway%2Faws4_request&X-Amz-Date=20210201T225801Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=dff6d2d6b29772129d10a43adf2b218d07b3cd3423ac13e32c71c6d7f8032eaf";

							if (connectionUrl.status == 'Success') {
								var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
								console.log('random hash: ' + hash);
								var clientIdHash = isNovaDevice ? this.state.currentDevice+"_"+connectionUrl.type : "g2_"+this.state.currentDevice+"_"+connectionUrl.type;
								this.state.client = new Paho.Client(connectionUrl.response, clientIdHash);
								this.state.client.onMessageArrived = this.onMessageArrived;
								this.state.client.onConnectionLost = this.onConnectionLost;
								const connectOptions = {
									timeout: 3,
									useSSL: true,
									mqttVersion: 4,
									cleanSession: true,
									onSuccess: this.onConnect,
									onFailure: (e) => {console.log("here is the error" , e); }
								};

								if (isNovaDevice) {
									connectOptions.timeout = 10;
									connectOptions.cleanSession = false;
									connectOptions.keepAliveInterval = 30;
								}

								this.state.client.connect(connectOptions);
							}
						},
						error => {
							console.log('error.message: ' + error.message);
						}
				);
	}

	checkIsConnected = () => {
		if (this.state.isReceivingMessages) {
			console.log("Vitals Is Connected!");
		} else {
			console.log("Vitals Is Not Connected!");
		}
	}

	updateIsConnected = () => {
		this.connectionTimeout = null;
		this.setState({isReceivingMessages: false});

		//localStorage.setItem('currentConnectedDevice', '');
		localStorage.setItem('isDeviceReceivingMessages', false);

		console.log("Vitals isReceivingMessages false");

		this.getUserVitalsHistoryData();
	}

	scheduleConnectionTimeout = () => {
		clearTimeout(this.connectionTimeout);
		this.connectionTimeout = setTimeout(this.updateIsConnected, this.connectionTimeoutDelay);
	}

	onMessageArrived(entry) {
		this.setState({isReceivingMessages: true});
	    console.log("Vitals onMessageArrived:"+entry.payloadString);
		const msg = this.normalizeVitalsMessage(JSON.parse(entry.payloadString));

		localStorage.setItem('currentConnectedDevice', JSON.stringify(msg.serial_num || this.state.currentDevice));
		localStorage.setItem('isDeviceReceivingMessages', true);

		if (this.isNovaDevice()) {
			this.setState({mainMessage: msg});
			console.log("nova vitals_main_messages:"+JSON.stringify(msg));
		} else if (msg.batch) {
			this.setState({mainMessage: JSON.parse(entry.payloadString)});
			console.log("vitals_main_messages:"+this.state.mainMessage);
		} else {
			this.setState({subMessage: JSON.parse(entry.payloadString)});
			console.log("vitals_sub_messages:"+this.state.subMessage);
		}
		this.scheduleConnectionTimeout();
  }

  onConnect = () => {
    const { client } = this.state;
    console.log("Connected!!!!");
    //client.subscribe('00013/out');
    this.setState({isConnected: true, error: ''})
		//this.setState({isReceivingMessages: true})
		//this.sendMessage("@@@get_all");
		console.log('myCurrentDevice id: ' + this.state.currentDevice);
		//this.setState({currentDevice: this.state.currentDevice});
		const subChannel = this.state.currentDevice+'/out';
		this.state.client.subscribe(subChannel);
		this.scheduleConnectionTimeout();
  };


  sendMessage(){
    var message = new Paho.Message(this.state.messageToSend);
    message.destinationName = "00013";

    if(this.state.isConnected){
      this.state.client.send(message);
    }else{
      this.connect(this.state.client)
        .then(() => {
          this.state.client.send(message);
          this.setState({error: '', isConnected: true});
        })
        .catch((error)=> {
          console.log(error);
          this.setState({error: error});
        });
  	}
  }


  onConnectionLost(responseObject) {
    if (responseObject.errorCode !== 0) {
      console.log("vitals onConnectionLost:"+responseObject.errorMessage);
      this.setState({error: 'Lost Connection', isConnected: false});
    }
  }

	getActiveNovaMessage = () => {
		const message = this.state.isReceivingMessages ? this.state.mainMessage : (this.state.userVitalsHistoryData || this.state.mainMessage);

		if (message && message.nova) {
			return message.nova;
		}

		return message || {};
	}

	getNovaPercent = (value) => {
		const number = this.getNumber(value);

		if (number == null) {
			return null;
		}

		return number>1 ? number : number*100;
	}

	getNovaRssiProgress = (rssi) => {
		const value = this.getNumber(rssi);

		if (value == null || value==0) {
			return 0;
		}

		const clamped = Math.max(-90, Math.min(-30, value));
		return Math.max(0, Math.min(100, ((clamped+90)/60)*100));
	}

	getNovaQuality = (progress) => {
		if (progress===0) {
			return "Offline";
		} else if (progress<33) {
			return "Poor";
		} else if (progress<66) {
			return "Weak";
		}

		return "Good";
	}

	getNovaQualityColor = (progress) => {
		if (progress===0) {
			return "secondary";
		} else if (progress<33) {
			return "danger";
		} else if (progress<66) {
			return "warning";
		}

		return "success";
	}

	getNovaBatteryColor = (percent) => {
		if (percent == null || percent<15) {
			return "danger";
		} else if (percent<35) {
			return "warning";
		} else if (percent<65) {
			return "yellow";
		}

		return "success";
	}

	renderNovaMetricRow(label, value, progress, color) {
		return (
			<Fragment>
				<Row className="mt-3">
					<Col xs="6" md="6" lg="6" className="text-left">
						<span>{label}</span>
					</Col>
					<Col xs="6" md="6" lg="6" className="text-right">
						<span>{value}</span>
					</Col>
				</Row>
				<Progress multi className="mt-1">
					<Progress bar color={color || "yellow"} value={progress || 0} />
				</Progress>
			</Fragment>
		);
	}

	renderNovaSignalCard(title, connected, rssi) {
		const progress = this.getNovaRssiProgress(rssi);
		const quality = connected===false ? "Offline" : this.getNovaQuality(progress);
		const color = connected===false ? "secondary" : this.getNovaQualityColor(progress);

		return (
			<Card className="card-hover h-100">
				<CardBody style={{ minHeight: 193 }}>
					<Row>
						<Col xs="8" md="8" lg="8">
							<CardTitle>{title}</CardTitle>
						</Col>
						<Col xs="4" md="4" lg="4" className="text-right">
							<i className={"mdi mdi-bluetooth mdi-24px text-"+(connected ? "success" : "secondary")} />
						</Col>
					</Row>
					<Row className="mt-2">
						<Col xs="6" md="6" lg="6" className="text-left">
							<span>Status</span>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<span>{connected ? "Connected" : "Offline"}</span>
						</Col>
					</Row>
					{this.renderNovaMetricRow("Strength", quality, progress, color)}
					<Row className="mt-3">
						<Col xs="6" md="6" lg="6" className="text-left">
							<span>RSSI</span>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<span>{rssi || "--"}</span>
						</Col>
					</Row>
				</CardBody>
			</Card>
		);
	}

	renderNovaBaseCard() {
		const message = this.getActiveNovaMessage();
		const base = message.base || {};
		const wifiProgress = this.getNovaRssiProgress(base.wifi_strength);
		const wifiQuality = base.wifi_connected===false ? "Offline" : this.getNovaQuality(wifiProgress);
		const wifiColor = base.wifi_connected===false ? "secondary" : this.getNovaQualityColor(wifiProgress);

		return (
			<Card className="card-hover">
				<CardBody style={{ minHeight: 193 }}>
					<Row>
						<Col xs="8" md="8" lg="8">
							<CardTitle>Base</CardTitle>
						</Col>
						<Col xs="4" md="4" lg="4" className="text-right">
							<i className={"mdi mdi-wifi mdi-24px text-"+(base.wifi_connected ? "success" : "secondary")} />
						</Col>
					</Row>
					<Row className="mt-2">
						<Col xs="6" md="6" lg="6" className="text-left">
							<span>Network</span>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<span>{base.wifi_name || "--"}</span>
						</Col>
					</Row>
					<Row className="mt-3">
						<Col xs="6" md="6" lg="6" className="text-left">
							<span>Status</span>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<span>{base.wifi_connected ? "Online" : "Offline"}</span>
						</Col>
					</Row>
					{this.renderNovaMetricRow("Strength", wifiQuality, wifiProgress, wifiColor)}
				</CardBody>
			</Card>
		);
	}

	renderNovaIndicators() {
		const message = this.getActiveNovaMessage();
		const base = message.base || {};
		const wand = message.wand || {};
		const pedal = message.pedal || {};
		const hasNovaData = base || wand || pedal;
		const batteryPercent = this.getNovaPercent(base.battery_level);
		const batteryVoltage = this.getNumber(base.battery_voltage);
		const batteryColor = this.getNovaBatteryColor(batteryPercent);
		const temp = this.getNumber(wand.laser_internal_temperature);
		const pedalBatteryPercent = this.getNovaPercent(pedal.battery_level);
		const pedalBatteryColor = this.getNovaBatteryColor(pedalBatteryPercent);

		if (!hasNovaData) {
			return null;
		}

		return (
				<Fragment>
					<Row>
						<Col lg="6" xl="4">
							{this.renderNovaSignalCard("Wand Signal Strength", wand.connected_to_base, wand.ble_signal_strength)}
						</Col>
						<Col lg="6" xl="4">
							<Card className="card-hover h-100">
								<CardBody style={{ minHeight: 193 }}>
									<Row>
										<Col xs="8" md="8" lg="8">
											<CardTitle>Internal Laser Temperature</CardTitle>
									</Col>
									<Col xs="4" md="4" lg="4" className="text-right">
										<i className={"mdi mdi-bluetooth mdi-24px text-"+(wand.connected_to_base ? "success" : "secondary")} />
									</Col>
								</Row>
								{this.renderNovaMetricRow("Temperature", temp!=null ? temp+"C" : "--", temp || 0, temp>80 ? "danger" : "yellow")}
								<Row className="mt-3">
									<Col xs="6" md="6" lg="6" className="text-left">
										<span>Wand</span>
									</Col>
									<Col xs="6" md="6" lg="6" className="text-right">
										<span>{wand.connected_to_base ? "Connected" : "Offline"}</span>
									</Col>
								</Row>
								</CardBody>
							</Card>
						</Col>
						<Col lg="6" xl="4">
							<Card className="card-hover h-100">
								<CardBody style={{ minHeight: 193 }}>
									<Row>
										<Col xs="8" md="8" lg="8">
											<CardTitle>Pedal</CardTitle>
										</Col>
										<Col xs="4" md="4" lg="4" className="text-right">
											<i className={"mdi mdi-bluetooth mdi-24px text-"+(pedal.connected_to_base ? "success" : "secondary")} />
										</Col>
									</Row>
									{this.renderNovaMetricRow("Signal", pedal.connected_to_base===false ? "Offline" : this.getNovaQuality(this.getNovaRssiProgress(pedal.ble_signal_strength)), this.getNovaRssiProgress(pedal.ble_signal_strength), pedal.connected_to_base===false ? "secondary" : this.getNovaQualityColor(this.getNovaRssiProgress(pedal.ble_signal_strength)))}
									{this.renderNovaMetricRow("Battery", pedalBatteryPercent!=null ? pedalBatteryPercent.toFixed(0)+"%" : "--", pedalBatteryPercent || 0, pedalBatteryColor)}
									<Row className="mt-3">
										<Col xs="6" md="6" lg="6" className="text-left">
											<span>RSSI</span>
										</Col>
										<Col xs="6" md="6" lg="6" className="text-right">
											<span>{pedal.ble_signal_strength || "--"}</span>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
						<Col lg="6" xl="4" className="mt-4">
							<Card className="card-hover h-100">
								<CardBody style={{ minHeight: 193 }}>
									<Row>
										<Col xs="8" md="8" lg="8">
											<CardTitle>Base Battery Pack Health</CardTitle>
										</Col>
										<Col xs="4" md="4" lg="4" className="text-right">
											<i className={"mdi "+(base.power_in_attached ? "mdi-power-plug text-success" : "mdi-battery text-"+batteryColor)+" mdi-24px"} />
										</Col>
									</Row>
									{this.renderNovaMetricRow("Battery", batteryPercent!=null ? batteryPercent.toFixed(0)+"%" : "--", batteryPercent || 0, batteryColor)}
									{this.renderNovaMetricRow("Cell 1", batteryVoltage!=null ? (batteryVoltage/2).toFixed(0)+"v" : "--", batteryPercent || 0, batteryColor)}
									{this.renderNovaMetricRow("Cell 2", batteryVoltage!=null ? (batteryVoltage/2).toFixed(0)+"v" : "--", batteryPercent || 0, batteryColor)}
								</CardBody>
							</Card>
						</Col>
				</Row>
			</Fragment>
		);
	}

	render() {
		var customizePath = "/customize/"+this.state.currentDevice;
		var remoteSupportPath = "/remotesupport/"+this.state.currentDevice;
		var vitalsDashboardPath = "/vitals-dashboard/"+this.state.currentDevice;
		var deviceLogs = "/device-logs/"+this.state.currentDevice;
		const isNovaDevice = this.isNovaDevice();
		const authToken = this.state.currentUser ? this.state.currentUser.jwtToken : "";
		return (
			<div>
				{this.state.noDevices &&
						<Row className="mb-3">
							<Col md="2">
								<h1 style={{color:'#e04e28'}}>{getDevicePageTitle(this.state.currentDevice, "Vitals", this.state.devices)}</h1>
							</Col>
							<Col md="2">
								<h4 className="pt-3">No Devices</h4>
							</Col>
						</Row>
				}
				{!this.state.noDevices &&
				<Fragment>
				<Row className="mb-3">
					<Col lg="6" xl="2">
						<h1 style={{color:'#e04e28'}}>{getDevicePageTitle(this.state.currentDevice, "Vitals", this.state.devices)}</h1>
					</Col>
					<Col lg="6" xl="4">
						<Row className="mb-3">
							<Col lg="6" xl="6" className="text-right">
								<h4 className="pt-3">Serial {this.state.currentDevice}</h4>
							</Col>
							<Col lg="6" xl="6" className="text-left">
								{this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']==2 &&
									<Fragment>
									{this.state.isReceivingMessages ? (
										<h3 style={{color: '#48b203'}} className="pt-2">( LIVE )</h3>
									) : (
										<Fragment>
										{this.state.userVitalsHistoryData &&
											<h3 style={{color: '#CD9706'}} className="pt-2">( HISTORICAL )</h3>
										}
										</Fragment>
									)}
									</Fragment>
								}
							</Col>
						</Row>
					</Col>
					<Col lg="6" xl="6">
						<div className="float-right">
							<Button color="dark" href={customizePath}>
								Customize
							</Button>
								{this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>0 &&
									<Fragment>
									{!isNovaDevice &&
										<Button className="ml-2" color="dark" href={remoteSupportPath}>
											Remote Support
										</Button>
									}
									<Button className="ml-2" color="dark" href={vitalsDashboardPath}>
										Dashboard
									</Button>
								<Button className="ml-2" color="dark" href={deviceLogs}>
									Device Logs
								</Button>
								</Fragment>
							}
						</div>
					</Col>
				</Row>
				<Row>
					<Col lg="6" xl="4">
						{isNovaDevice ? (
							<TopProceduresCatNova key={`top-procedures-cat-nova-${this.state.currentDevice}`} source="desktop-vitals" currentDevice={this.state.currentDevice} authToken={authToken} product="2" version={1} cardMinHeight={473} contentHeight={275} navContentHeight={300} contentOverflowX="hidden" contentOverflowY="auto" contentScrollClassName="nova-vitals-scroll" />
						) : (
							<TopProceduresCat currentDevice={this.state.currentDevice} />
						)}
					</Col>
					<Col lg="6" xl="4">
						{!isNovaDevice &&
							<BatteryHealth historyMessage={this.state.userVitalsHistoryData} message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice}/>
						}
						<TotalHourlyUsagePVM currentDevice={this.state.currentDevice} />
						{isNovaDevice &&
							this.renderNovaBaseCard()
						}
					</Col>
					<Col lg="6" xl="4">
						<WavelengthUsage currentDevice={this.state.currentDevice} />
					</Col>
					{!isNovaDevice &&
						<Col lg="6" xl="4">
							<WifiStrength historyMessage={this.state.userVitalsHistoryData} message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice} />
							<BleStrength historyMessage={this.state.userVitalsHistoryData} message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice} />
						</Col>
					}
					{!isNovaDevice &&
						<Col lg="6" xl="4">
							<VisualAudioStatus historyMessage={this.state.userVitalsHistoryData} message={this.state.mainMessage} isReceivingMessages={this.state.isReceivingMessages} currentDevice={this.state.currentDevice}/>
						</Col>
					}
					{!isNovaDevice &&
						<Col lg="6" xl="4">
							<Booster200V historyMessage={this.state.userVitalsHistoryData} message={this.state.mainMessage} currentDevice={this.state.currentDevice} isReceivingMessages={this.state.isReceivingMessages} />
						</Col>
					}
				</Row>
				{isNovaDevice &&
					this.renderNovaIndicators()
				}
				</Fragment>
				}
			</div>
		);
	}
}

export default Vitals;
